import styled from '@emotion/styled'

import Button from '@segment/matcha/components/Button'
import IconWrapper from '@segment/matcha/components/IconWrapper'
import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'
import { ChartIcon, ReportIcon, UserIcon } from '@segment/matcha/components/Icons/Brandbook'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

const copy = {
  heading: `Why partner with Segment?`,
  description: `See why Twilio’s CDP is ranked #1 for market share four years in a row per IDC, (2019-2022)`,
}

const data = [
  {
    icon: <ReportIcon />,
    title: `Become an expert`,
    body: `Gain certification on Twilio, the #1 CDP for 2022 worldwide market share by IDC, to better serve your customers.`,
  },

  {
    icon: <UserIcon />,
    title: `Access a dedicated team`,
    body: `Work with Segment's partner team for sales support, co-marketing initiatives, and proofs of concept.`,
  },

  {
    icon: <ChartIcon />,
    title: `Grow your business`,
    body: `Fuel sales with go-to-market opportunities that amplify your brand exposure and generate qualified leads.`,
  },
]

const joinButton = {
  text: `Join Twilio Segment`,
  url: `https://partners.segment.com/English/register_email.aspx/`,
}

const PartnerWithSegment = () => {
  return (
    <SectionBase variant="noCopy">
      <StyledSectionContents>
        <StyledCopyText centered={true}>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          <CopyText.Description tag="p">{copy.description}</CopyText.Description>
        </StyledCopyText>
        <ColumnTrack columns={1} overrides={{ md: 3 }}>
          {data.map((feature) => (
            <FeatureWrapper key={feature.title} alignment="left" headerPosition="top">
              <FeatureBox.Header>
                <IconWrapper elevation={1} variant="circle">
                  {feature.icon}
                </IconWrapper>
              </FeatureBox.Header>
              <FeatureBox.Body>
                <FeatureBox.Title variant="h4">{feature.title}</FeatureBox.Title>
                <FeatureBox.Text>{feature.body}</FeatureBox.Text>
              </FeatureBox.Body>
            </FeatureWrapper>
          ))}
        </ColumnTrack>
        <BottomInfo>
          <Button size="large" variant="filled" color="primary" tag="a" href={joinButton.url} target="_blank">
            {joinButton.text}
          </Button>
        </BottomInfo>
      </StyledSectionContents>
    </SectionBase>
  )
}

const StyledSectionContents = styled(Section.Contents)`
  max-width: 1120px;
  margin: 0 auto;
  display: grid;
  gap: 40px;

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    gap: 80px;
  }
`

const StyledCopyText = styled(CopyTextBase)`
  margin: 0 auto;
  max-width: 684px;
`

const FeatureWrapper = styled(FeatureBoxBase)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 350px;
  }
`

const BottomInfo = styled.div`
  text-align: center;
`

export default PartnerWithSegment
